/** Множители для округления цен до фиксированного числа знаков: умножить → округлить → разделить */
export enum FractionDivisorEnum {
	HUNDREDTHS = 100,
	TEN_THOUSANDTHS = 10000,
}
